import { StockStatus } from "../types/ProductStockStatus";

export const stockStatusNameToIdMap: { [index: string]: number } = {
  [StockStatus.DUE_IN]: 1,
  [StockStatus.AVAILABLE]: 2,
  [StockStatus.RESERVED]: 3,
  [StockStatus.DAMAGED]: 4,
  [StockStatus.UNAVAILABLE]: 5,
};
